import { TextField } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { MoneyMaskedInput2 } from "../../../../../../common/components/masked_inputs/money_masked_input2";

type Props = {
  OnActionValorChange(idItemServicoEmpreendimento: number, newValue: number | null): void;
  OnActionQuantidadeChange(idItemServicoEmpreendimento: number, newValue: number | null,): void;
};
export const GenerateItemServicoEmpreendimentoColumns = ({
  OnActionValorChange,
  OnActionQuantidadeChange,
}: Props): GridColDef[] => {
  return [
    {
      field: "descricaoServico",
      filterable: false,
      headerName: "Produto",
      flex: 1,
      minWidth: 350,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "descricaoBloco",
      filterable: false,
      headerName: "Bloco",
      flex: 1,
      minWidth: 200,
      width: 200,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "descricaoAndar",
      filterable: false,
      headerName: "Andar",
      flex: 1,
      minWidth: 200,
      width: 200,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "descricaoUnidade",
      filterable: false,
      headerName: "Unidade Imovel",
      flex: 1,
      minWidth: 200,
      width: 200,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "unidade",
      filterable: false,
      headerName: "Unidade Medida",
      minWidth: 110,
      width: 110,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Quantidade",
      filterable: false,
      minWidth: 150,
      width: 150,
      headerName: "Quantidade Prevista",
      sortable: false,
      renderCell: (params) => {
        const id = params.row['idItemServicoEmpreendimento'] as number;
        const quantidade = params.row['quantidade'] as number;
        return (
          <div className="w-full flex items-center justify-center h-full p-1">
            <TextField
              size="small"
              fullWidth
              type="number"
              variant="outlined"
              value={quantidade ?? ""}
              onChange={(e) => {
                const valor = e.target.value ? Number(e.target.value) : null;
                OnActionQuantidadeChange(id, valor);
              }}
            />
          </div>
        );
      },
    },
    {
      field: "valorUnitario",
      filterable: false,
      minWidth: 180,
      width: 180,
      headerAlign: "center",
      headerName: "Valor Unitário",
      sortable: false,
      renderCell: (params) => {
        const id = params.row['idItemServicoEmpreendimento'] as number;
        const value = params.row['valorUnitario'] as number | null | undefined;

        return (
          <div className="w-full flex items-center justify-center h-full p-1">
            <MoneyMaskedInput2
              name="ValorUnitario"
              label=""
              readOnly={false}
              value={value == null ? "" : value.toString()}
              onChange={(novoValor) => {
                OnActionValorChange(id, Number(novoValor));
              }}
            />
          </div>
        );
      },
    },
  ];
};
